module.exports = __webpack_public_path__ + "static/media/result_fhl_ja.77eee779.jpg";